import { create } from "zustand";
import { useFetchDistrictSlice } from "../slices/BrickManagementSlices/fetchDistrictSlice";
import { useFetchClusterSlice } from "../slices/BrickManagementSlices/fetchClusterSlice";
import { useAddBrickSlice } from "../slices/BrickManagementSlices/addBrick";
import { useUpdateBrickSlice } from "../slices/BrickManagementSlices/updateBrick";
import { useFetchBrickManagementSlice } from "../slices/BrickManagementSlices/fetchBrickManagement";
import { useDeactivateBrickSlice } from "../slices/BrickManagementSlices/deactivateBrick";
import { useFetchAutoCompleteLocationSlice } from "../slices/BrickManagementSlices/fetchAutoCompleteLocationSlice";
import { useFetchMapLocationSlice } from "../slices/BrickManagementSlices/fetchMapLocationSlice";
import { useFetchBrickAreaLocationSlice } from "../slices/BrickManagementSlices/fetchBrickAreaLocationSlices";
import { useAddStoreBrickAreaLocationSlice } from "../slices/BrickManagementSlices/addStoreBrickAreaLocationSlices";
import { useFetchMapDistanceSlice } from "../slices/BrickManagementSlices/fetchMapDistanceSlice";
import { useFetchMaxLocationLimitSlice } from "../slices/BrickManagementSlices/fetchMaxLocationLimitSlice";
import { useFetchBaseBrickLocationSlice } from "../slices/BrickManagementSlices/fetchBaseBrickLocationSlice";

interface BrickManagementInterface
  extends ReturnType<typeof useFetchDistrictSlice>,
    ReturnType<typeof useFetchClusterSlice>,
    ReturnType<typeof useAddBrickSlice>,
    ReturnType<typeof useUpdateBrickSlice>,
    ReturnType<typeof useFetchBrickManagementSlice>,
    ReturnType<typeof useDeactivateBrickSlice>,
    ReturnType<typeof useFetchAutoCompleteLocationSlice>,
    ReturnType<typeof useFetchMapLocationSlice>,
    ReturnType<typeof useFetchBrickAreaLocationSlice>,
    ReturnType<typeof useAddStoreBrickAreaLocationSlice>,
    ReturnType<typeof useFetchMapDistanceSlice>,
    ReturnType<typeof useFetchMaxLocationLimitSlice>,
    ReturnType<typeof useFetchBaseBrickLocationSlice> {}

export const BrickManagementStore = create<BrickManagementInterface>(
  (...a) => ({
    ...useFetchDistrictSlice(...a),
    ...useFetchClusterSlice(...a),
    ...useAddBrickSlice(...a),
    ...useUpdateBrickSlice(...a),
    ...useFetchBrickManagementSlice(...a),
    ...useDeactivateBrickSlice(...a),
    ...useFetchAutoCompleteLocationSlice(...a),
    ...useFetchMapLocationSlice(...a),
    ...useFetchBrickAreaLocationSlice(...a),
    ...useAddStoreBrickAreaLocationSlice(...a),
    ...useFetchMapDistanceSlice(...a),
    ...useFetchMaxLocationLimitSlice(...a),
    ...useFetchBaseBrickLocationSlice(...a),
  })
);
